import type { Currency } from "@/services/currencies";

/**
 * Add currency symbol to given string (=already formatted number). Do not perform number formatting.
 * @deprecated
 */
export function addCurrencySymbol(price: string, currency: Currency, html = false): string {
  const separator = currency.isSpaceSeparator ? " " : "";
  let symbol = currency.symbol;
  if (html) {
    symbol = '<span class="currency">' + symbol + "</span>";
  }

  if (currency.isPositionLeft) {
    return symbol + separator + price;
  } else {
    return price + separator + symbol;
  }
}
